import { TextConfigurationContent } from '@/types';
import { hasOwnProperty } from '@/utils/hasOwnProperty';
import { isComplexTextContent } from './isComplexTextContent';

export const getTextContent = (content: (string | TextConfigurationContent)[]) => {
  let result = isComplexTextContent(content[0]) ? content[0].content.join(' ') : content[0];

  if (content.length === 1) {
    return result;
  }

  for (let i = 1; i < content.length; i++) {
    const contentElement = content[i];
    if (!isComplexTextContent(contentElement)) {
      result += `\n${contentElement}`;
    } else if (hasOwnProperty(contentElement, 'x')) {
      // a second content element in the array with an x and y property marks a line break
      result += `\n${contentElement.content}`;
    } else {
      // if there is no x property yet the element is still on the same line as the one(s) before
      result += ` ${contentElement.content}`;
    }
  }
  return result;
};
